const colors = {
    darkPurple: "#663399",
    lightPurple: "#ccb3e6",
    white: "#ffffff",
    black: "#000000",
}

export default colors
